/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';
import {
  AnalyzeContext,
  AnalyzeIssue,
  AnalyzeResult,
  getDataStoreItem,
} from 'layout/Sidebar/panels/TreeView/AnalyzeUtils';
import { getManager } from '../../registry/Manager';

export async function analyzeActionButton({
  itemId,
  page,
  mgr,
}: AnalyzeContext): Promise<AnalyzeResult> {
  const alerts: AnalyzeIssue[] = [];
  const autoFixes: (() => void)[] = [];
  const item = page[itemId] as Item<'ActionButton'>;
  if (item.props.alias) {
    const dsItem = getDataStoreItem({ page, alias: item.props.alias });
    if (dsItem) {
      let addAlert = false;
      switch (item.props.action) {
        case 'Save':
          addAlert =
            dsItem.type !== 'DataStore' && dsItem.type !== 'CloudDataStore';
          break;
        case 'Refresh':
          addAlert = dsItem.type === 'TransientDataStore';
          break;
        case 'Create':
        case 'Clear And Create':
        case 'Delete':
        case 'Delete Selected':
        case 'Reset':
          addAlert = dsItem.type === 'ReadOnlyDataStore';
          break;
        default:
      }
      if (addAlert) {
        const m = getManager(dsItem.type);
        alerts.push({
          key: `invalid-ds-${itemId}`,
          showItemId: itemId,
          alert: `${m.name} [${item.props.alias}] cannot be used in ${mgr.name} for the action ${item.props.action}!`,
          itemId,
        });
      }
    }
  }
  return [alerts, autoFixes];
}
